import React, { useState, useEffect, useRef } from 'react';

const LazySection = ({ children, rootMargin = '200px' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  const style = {};
  if (!prefersReducedMotion) {
    style.opacity = isVisible ? 1 : 0;
    style.transform = isVisible ? 'none' : 'translateY(20px)';
    style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  }

  return (
    <div ref={ref} style={style}>
      {isVisible ? children : null}
    </div>
  );
};

export default LazySection;
